const mobile = /^1[3,4,5,6,7,8,9]{1}[0-9]{1}[0-9]{8}$/;
import qs from 'qs';

export default {
  data() {
    return {
      formData: {},
      addressOptions: [],
      submitting: false,
      rules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'change' }],
        companyName: [{ required: true, message: '请填写公司名词', trigger: 'change' }],
        district: [{ required: true, message: '请选择地址', trigger: 'change' }],
        phone: [
          { required: true, message: '请填写手机号码' },
          {
            validator(rule, value, callback) {
              if (mobile.test(value)) {
                callback();
              } else {
                callback('请输入正确的手机号码');
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {},
  methods: {
    doSubmit() {
      const { formData } = this;
      this.submitting = true;
      return this.$http
        .post(
          process.env.NODE_ENV === 'production'
            ? 'https://ad.wkanx.com/v2/advertising/marketing/submit'
            : 'http://117.50.2.56:8998/v2/advertising/marketing/submit',
          qs.stringify({
            ...formData,
            district: formData.district.join(';'),
          }),
        )
        .then(res => {
          setTimeout(() => {
            this.submitting = false;
          }, 2000);
          return res;
        })
        .catch(err => {
          this.submitting = false;
          return err;
        });
    },
    getRegionTree() {
      if (this.addressOptions.length) return;
      this.$http
        .get('https://static.wkanx.com/static/cjs/address.json')
        .then(res => {
          const { data } = res.data;
          function preprocess(data) {
            data.forEach((i, idx) => {
              if (typeof i === 'string') {
                data[idx] = { name: i };
              } else if (i.child) {
                preprocess(i.child);
              }
            });
          }
          preprocess(data);
          this.addressOptions = data;
          // console.log(11, this.addressOptions);
        })
        .catch(err => {
          console.log(22, err);
        });
    },
  },
};
